import React from "react";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { AdminRecordInterface, setEditId, setEditError, selectAdminById } from "src/store/watcher/adminsSlice";
import { updateAdmin } from "src/actions/watcher/adminsActions";

import DrawerRight from "src/componets/DrawerRight";
import Form from './_partials/_Form';
import AlertBlock from "src/componets/AlertBlock";

const Edit = () => {
  const dispatch = useAppDispatch();
  const id: any = useAppSelector(state => state.watcher.admins.editId);
  const error   = useAppSelector(state => state.watcher.admins.editError);
  const admin   = useAppSelector(state => selectAdminById(state, id));

  function onCloseError() {
    dispatch(setEditError(null));
  }

  function onClose() {
    dispatch(setEditId(null));
  }

  function onFinish(data: AdminRecordInterface) {
    handleSave(data).catch(console.error);
  }

  async function handleSave(data: object) {
    const resultAction = await dispatch(updateAdmin({ id, data }));

    if (updateAdmin.fulfilled.match(resultAction)) {
      onClose();
    }
  }

  return (
    <DrawerRight
      open={!!id}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-edit-admin'>
        <h6 className="v-content-label">Edit Admin</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form params={admin} onFinish={onFinish} />
      </div>
    </DrawerRight>
  )
}

export default Edit;
